module.exports = __webpack_public_path__ + "static/media/manumaps.d248bd66.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/manumaps.png
// module id = 33
// module chunks = 0